import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

export class VipRoomProductBooking extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/vipRoomProductBooking'
		this.desc = '贵宾休息室预订'
	}
}

export class OneStopProductBooking extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/oneStopProductBooking'
		this.desc = '一条龙服务预订'
	}
}

export class StopWayProductBooking extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/stopWayProductBooking'
		this.desc = '快速停车道预订'
	}
}

export class EuqityPackageProductBooking extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/euqityPackageProductBooking'
		this.desc = '权益包预订'
	}
}

export class AbroadConfig extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/outbound/third/config'
		this.desc = '查询第三方出国宝的相关映射配置'
	}
}

export class AbroadCitys extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/outbound/third/citys'
		this.desc = '查询第三方出国宝相关城市数据'
	}
}

export class AbroadHotel extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/outbound/hotels'
		this.desc = '酒店模糊查询接口'
	}
}

export class AbroadPassport extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/outbound/ocr/passport'
		this.desc = 'ocr护照图片上传解析'
	}
}

export class AbroadPassport2 extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/outbound/ocr/passport2'
		this.desc = 'ocr护照识别'
	}
}

export class AbroadTripInfoCheck extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/outbound/travelInfo/check'
		this.desc = '行程表单项检查'
	}
}

export class AbroadPassportCheck extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/outbound/passport/check'
		this.desc = '护照项检查'
	}
}

export class OutboundProductBooking extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/outbound/outboundProductBooking'
		this.desc = '出入境产品预订'
	}
}

export class StopWayOverTimeBooking extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/stopWayOverTimeBooking'
		this.desc = '下单快速接机道超时费'
	}
}

export class QueryProductCouponDetail extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/queryProductCouponDetail'
		this.desc = '产品优惠券详情'
	}
}

export class QueryUserProductCoupon extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BOOKING
		this.url = '/bookingCoupon/queryUserProductCoupon'
		this.desc = '查询预定优惠券'
	}
}

export class QueryPromotionProductDiscountList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BOOKING
		this.url = '/booking/queryPromotionProductDiscountList'
		this.desc = '产品促销活动折扣列表'
	}
}
